/* eslint-disable no-restricted-syntax -- Not translatable strings */
import classNames from "classnames";
import omit from "lodash/omit";
import type { ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { IconButton } from "../HeaderV3/IconButton";
import { InsertVariableButtonV4 } from "../InsertVariableButtonV4";
import type { Variable } from "./InsertVariableButtonWrapper";
import { InsertVariableButtonWrapper } from "./InsertVariableButtonWrapper";

const memberGroup = () => t("dynamic_vars_groups.member");

export const DEFAULT_VARIABLES: Variable[] = [
  {
    get group() {
      return memberGroup();
    },
    label: "{{member.first_name}}",
    value: "{{member.first_name}}",
  },
  {
    get group() {
      return memberGroup();
    },
    label: "{{member.last_name}}",
    value: "{{member.last_name}}",
  },
  {
    get group() {
      return memberGroup();
    },
    label: "{{member.name}}",
    value: "{{member.name}}",
  },
  {
    get group() {
      return memberGroup();
    },
    label: "{{member.email}}",
    value: "{{member.email}}",
  },
  {
    get group() {
      return memberGroup();
    },
    label: "{{member.public_uid}}",
    value: "{{member.public_uid}}",
  },
];

interface InsertVariableButtonProps extends Omit<
  ComponentPropsWithoutRef<typeof InsertVariableButtonWrapper>,
  "children"
> {
  className?: string;
  tooltipPlacement?: "top" | "bottom";
}

export const InsertVariableButton = ({
  tooltipPlacement = "bottom",
  className,
  ...rest
}: InsertVariableButtonProps) => {
  const isV4 = useIsCircleV4FeatureEnabled("circle_v4_form_elements_enabled");

  if (isV4) {
    const v4Props = omit(rest, [
      "wrapperClassName",
      "optionsClassName",
      "shouldRenderPortal",
    ]);
    return <InsertVariableButtonV4 {...v4Props} />;
  }

  return (
    <InsertVariableButtonWrapper {...rest}>
      <TippyV2
        placement={tooltipPlacement}
        delay={300}
        content={t("tiptap.add_variable")}
        interactive={false}
      >
        <IconButton
          iconSize={20}
          buttonSize={32}
          name="20-variables"
          className={classNames(
            "disabled:cursor-not-allowed disabled:opacity-40",
            className,
          )}
          ariaLabel={t("tiptap.add_variable")}
        />
      </TippyV2>
    </InsertVariableButtonWrapper>
  );
};
